"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.object({
    email: zod_1.z.string().regex(/^[^\s@]+@[^\s@]+\.[^\s@]+$/),
    language: zod_1.z.string().min(1),
    hubApp: zod_1.z.string().min(1),
});
exports.path = '/landing-page-self-registration-request';
//# sourceMappingURL=index.js.map